import React, { useRef, useState, useEffect } from 'react';
import { FaPlay } from 'react-icons/fa'; // Need to install react-icons

const VideoPlayer = ({ videoSource }) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true); // Set initial state to true
    const [currentTime, setCurrentTime] = useState(0);

    // Autoplay when component mounts
    useEffect(() => {
        if (videoRef.current) {
            // Some browsers require muted for autoplay to work
            videoRef.current.muted = true;
            videoRef.current.play()
                .then(() => {
                    // Unmute after successful autoplay
                    videoRef.current.muted = false;
                })
                .catch(error => {
                    console.error("Autoplay failed:", error);
                    setIsPlaying(false);
                });
        }
    }, [videoSource]);

    const togglePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handleTimeUpdate = () => {
        if (videoRef.current) {
            setCurrentTime(videoRef.current.currentTime);
        }
    };

    const handleSeekbarClick = (e) => {
        if (videoRef.current) {
            const clickedTime = (e.nativeEvent.offsetX / e.currentTarget.offsetWidth) * videoRef.current.duration;
            videoRef.current.currentTime = clickedTime;
            setCurrentTime(clickedTime);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ position: 'relative', width: '30%' }}>
                <video
                    ref={videoRef}
                    src={videoSource}
                    onClick={togglePlayPause}
                    onTimeUpdate={handleTimeUpdate}
                    loop
                    autoPlay
                    style={{ width: '100%', height: 'auto', borderRadius: '5px' }}
                />

                {/* Pause/Play Icon Overlay - now with its own click handler */}
                {!isPlaying && (
                    <div
                        onClick={togglePlayPause} // Same handler as the video
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer' // Add pointer cursor
                        }}
                    >
                        <FaPlay style={{ color: 'white', fontSize: '16px' }} />
                    </div>
                )}
            </div>

            <div
                style={{ width: '30%', height: '5px', background: '#ccc', cursor: 'pointer', marginTop: '10px', borderRadius: '5px' }}
                onClick={handleSeekbarClick}
            >
                <div
                    style={{
                        width: `${(currentTime / (videoRef.current?.duration || 1)) * 100}%`,
                        height: '100%',
                        background: '#4A2FBD',
                        borderRadius: '5px'
                    }}
                />
            </div>
        </div>
    );
};

export default VideoPlayer;
